<pp-not-authorized-layout
  [ppHideLogo]="rebrandEnabled()"
  [class.loginScreen]="hubspotMarketingPageUrl"
>
  <section class="authBox">
    @if (rebrandEnabled()) {
      <section class="login__logo-container">
        <div class="login__logo">
          <pp-brand-logo></pp-brand-logo>
        </div>
      </section>
    }
    <header>
      <h4>{{ 'login' | ppTranslate }}</h4>
      <p class="authBox__copy">{{ 'please_enter_your_details' | ppTranslate }}.</p>
    </header>

    <form class="authBox__inputs-container" novalidate [formGroup]="authForm">
      <section>
        <div class="authBox__input-wrapper" [class.login__error-border]="shouldShowError('email')">
          <label class="sr-only" for="signin-email"> {{ 'email' | ppTranslate }} </label>
          <pp-icon
            [ppSVG]="mailIcon"
            alt="outline of a letter"
            ppColor="grey-600"
            ppClass="setSize18"
          />

          <input
            id="signin-email"
            class="authBox__input"
            name="email"
            autocomplete="email"
            type="email"
            [placeholder]="'enter_your_email' | ppTranslate"
            (keydown.enter)="onKeyDownEnter($event)"
            autofocus
            required
            formControlName="email"
            data-test="email-input"
            (input)="onInput('email')"
            (blur)="onBlur('email')"
          />
        </div>

        <div class="login__error-msg" [class.login__error-msg--hidden]="!shouldShowError('email')">
          @if (shouldShowError('email')) {
            @if (authForm.get('email')?.errors?.['required']) {
              <pp-icon [ppSVG]="warningIcon" ppClass="setSize18" />
              <p data-test="email-required-message">{{ 'enter_your_email' | ppTranslate }}</p>
            } @else if (authForm.get('email')?.errors?.['email']) {
              <pp-icon [ppSVG]="warningIcon" ppClass="setSize18" />
              <p data-test="email-invalid-message">
                {{ 'enter_valid_email_address' | ppTranslate }}
              </p>
            }
          }
        </div>
      </section>
      <section>
        <div
          class="authBox__input-wrapper"
          [class.login__error-border]="shouldShowError('password')"
        >
          <label class="sr-only" for="signin-password">
            {{ 'enter_your_password' | ppTranslate }}
          </label>
          <pp-icon
            [ppSVG]="passwordIcon"
            alt="outline of a lock"
            ppColor="grey-600"
            ppClass="setSize18"
          />

          <pp-password-visibility (ppVisibilityChange)="passInputType = $event" />

          <input
            id="signin-password"
            class="authBox__input"
            name="signin-password"
            autocomplete="current-password"
            [type]="passInputType"
            [placeholder]="'enter_your_password' | ppTranslate"
            (keydown.enter)="onKeyDownEnter($event)"
            required
            data-test="password-input"
            formControlName="password"
            (input)="onInput('password')"
            (blur)="onBlur('password')"
          />
        </div>

        <div
          class="login__error-msg"
          [class.login__error-msg--hidden]="!shouldShowError('password')"
        >
          @if (shouldShowError('password')) {
            <pp-icon
              [ppSVG]="warningIcon"
              ppColor="grey-600"
              [ppDisplayContents]="true"
              ppClass="setSize18"
            />
            <p data-test="password-required-message">{{ 'enter_your_password' | ppTranslate }}</p>
          }
        </div>
      </section>
    </form>

    <footer class="authBox__footer--gap-l">
      <div class="login__row">
        @if (!(isiPhone || isiPod || isiPad)) {
          <div class="form-group login__remember">
            <pp-checkbox
              [ppChecked]="rememberMe"
              ppType="solid"
              (ppOnValueChange)="onRememberMeChecked()"
              [ppAriaLabel]="'remember_me' | ppTranslate"
            />

            <label class="authBox__label">
              {{ 'remember_me' | ppTranslate }}
            </label>
          </div>
        }

        <button
          class="login__password-button"
          data-test="forgotPasswordButton"
          (click)="forgotPassword()"
        >
          {{ 'forgot_password' | ppTranslate }}
        </button>
      </div>

      <pp-button
        ppStyle="primary"
        ppSize="large"
        ppId="logInBtn"
        [ppProcess]="processing"
        data-test="loginButton"
        (ppAction)="login()"
      >
        {{ 'sign_in' | ppTranslate }}
      </pp-button>
    </footer>
  </section>
</pp-not-authorized-layout>

@if (hubspotMarketingPageUrl) {
  <div
    class="media-bridge-container-wrapper"
  >
    <div class="media-bridge-container">
      <iframe
        [src]="hubspotMarketingPageUrl"
        width="100%"
        height="100%"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </div>
}
